import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Button as AntdButton, Flex, Form, InputNumber, message, Input, Select, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { convertToBase64 } from '../../../shared/utils';
import Icon from '../../../components/common/Icon';
import { createCategoryAction, deleteCategory, updateCategoryAction } from '../../../store/EditoreSlice';
import { LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelCardFooter, LeftPanelCardHead, LeftPanelContainer, } from '../editor.style';
import CustomColorPicker from '../components/ColorPicker';
const initialValues = {
    name: '',
    iconFromDefaultList: '',
    sortOrder: 1,
    color: null,
    externalId: '',
    imageUrl: [],
};
const CategoryPanel = ({ categoryData, siteId, isOpen, onBack }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [container, setContainer] = useState(null);
    const [editCategory, setEditCategory] = useState(false);
    useEffect(() => {
        if (categoryData) {
            form.setFieldsValue(categoryData);
            setEditCategory(categoryData);
        }
        else {
            form.setFieldsValue(initialValues);
            setEditCategory(false);
        }
    }, [categoryData]);
    const { createCategory: { loading: creatingCategory }, updateCategory: { loading: updatingCategory }, deleteCategory: { loading: deletingCategory }, } = useSelector((state) => state?.editor);
    const categoryIcons = useSelector((state) => state?.editor?.categoryIcons?.response);
    return (_jsx(_Fragment, { children: _jsx(LeftPanel, { isOpen: isOpen, style: {
                width: '340px',
            }, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [_jsx(LeftPanelCardHead, { children: _jsxs(Flex, { align: "center", children: [_jsx(AntdButton, { style: { marginLeft: '-8px' }, color: "default", variant: "text", icon: _jsx(Icon, { icon: "arrow-left", size: 18 }), onClick: () => {
                                            onBack();
                                        } }), _jsx("h3", { children: !!editCategory ? 'Edit Category' : 'Create New Category' })] }) }), _jsx(LeftPanelCardBody, { style: { padding: '0 16px 16px' }, ref: setContainer, children: _jsxs(Form, { initialValues: editCategory || initialValues, form: form, layout: "vertical", onFinish: async (values) => {
                                    if (!siteId)
                                        return;
                                    let payload = { ...values };
                                    // Process color field
                                    if (payload.color) {
                                        payload.color =
                                            typeof payload.color === 'object'
                                                ? {
                                                    rgba: payload.color.toRgbString(),
                                                    hex: payload.color.toHexString(),
                                                    opacity: payload.color.toRgb().a || 1,
                                                }
                                                : editCategory?.['color-origin'];
                                    }
                                    else {
                                        payload.color = null;
                                    }
                                    let fileUpload = {};
                                    // Handle image file conversion to base64 if imageUrl is present
                                    if (payload.imageUrl?.length > 0 && payload.imageUrl[0].originFileObj) {
                                        const base64 = (await convertToBase64(payload.imageUrl[0].originFileObj)).split(',')[1];
                                        fileUpload.imageUrl = base64;
                                    }
                                    const actionPayload = {
                                        data: {
                                            ...payload,
                                            siteId: siteId ?? payload.siteId,
                                        },
                                        fileUpload,
                                    };
                                    // Choose action based on whether editCategory is set
                                    const action = editCategory
                                        ? updateCategoryAction({
                                            siteId,
                                            categoryId: editCategory.categoryId,
                                            ...actionPayload,
                                        })
                                        : createCategoryAction(actionPayload);
                                    // Dispatch the action and handle response
                                    dispatch(action).then((res) => {
                                        if (!res.error) {
                                            message.success(editCategory ? 'Category updated successfully' : 'Category created successfully');
                                            form.resetFields();
                                            onBack();
                                        }
                                        else {
                                            message.error(res?.payload?.message || 'Something went wrong');
                                        }
                                    });
                                }, children: [_jsx(Form.Item, { name: "name", label: "Name", required: true, tooltip: "This is a required field", rules: [{ required: true, message: 'Name is required' }], children: _jsx(Input, { placeholder: "Category Name", variant: "filled" }) }), _jsx(Form.Item, { name: "iconFromDefaultList", label: "Icon From Default List", required: true, tooltip: "This is a required field", rules: [{ required: true }], children: _jsx(Select, { showSearch: true, variant: "filled", allowClear: true, placeholder: "Select Icon", options: Object.keys(categoryIcons || {}).map((item) => ({
                                                label: item
                                                    .replace(/_/g, ' ')
                                                    .toLowerCase()
                                                    .replace(/\b\w/g, (c) => c.toUpperCase()),
                                                value: item,
                                            })).sort((a, b) => {
                                                if (a?.label < b?.label) {
                                                    return -1; // a comes before b
                                                }
                                                if (a?.label > b?.label) {
                                                    return 1; // b comes before a
                                                }
                                                return 0; // a and b are equal
                                            }) }) }), _jsx(Form.Item, { label: "Sort Order", tooltip: "Enter the sort order of the location", name: "sortOrder", children: _jsx(InputNumber, { placeholder: "Enter sort order", min: 1, step: 1, variant: "filled", style: { width: '100%' } }) }), _jsx(Form.Item, { label: "Color", tooltip: "This is a required field", name: 'color', children: _jsx(CustomColorPicker, {}) }), _jsx(Form.Item, { label: "External Id", tooltip: "This is a required field", name: 'externalId', children: _jsx(Input, { placeholder: "External Id", variant: "filled" }) })] }) }), _jsxs(LeftPanelCardFooter, { children: [_jsx(Button, { loading: deletingCategory, onClick: () => {
                                        if (!!editCategory) {
                                            if (siteId) {
                                                dispatch(deleteCategory({
                                                    siteId,
                                                    categoryId: editCategory.categoryId,
                                                }))
                                                    .then((res) => {
                                                    //@ts-ignore
                                                    if (!res.error) {
                                                        message.success('Category deleted successfully');
                                                        onBack();
                                                    }
                                                    else {
                                                        message.error('Something went wrong');
                                                    }
                                                })
                                                    .catch((error) => {
                                                    console.error(error);
                                                    message.error('Something went wrong');
                                                });
                                            }
                                        }
                                        else {
                                            onBack();
                                        }
                                    }, color: "danger", variant: "filled", children: !!editCategory ? 'Delete' : 'Cancel' }), _jsx(Button, { loading: creatingCategory || updatingCategory, onClick: () => {
                                        form.submit();
                                    }, color: "primary", variant: "solid", children: "Save" })] })] }) }) }) }));
};
export default React.memo(CategoryPanel);
